export default {
    formatPoints,
    formatAmount
};


function formatPoints(points) {
    const pattern = /\B(?=(\d{3})+(?!\d))/g;
    return points.toString().replace(pattern, '.');
}

function formatAmount(amount) {
    return amount
        .toFixed(2)
        .replace('.', ',')
        .replace(/(\d)(?=(\d{3})+,)/g, '$1.');
}


// WEBPACK FOOTER //
// ./src/utils/FormatValue.js